<template>
  <div class="w3-container contacts" v-if="user">
    <button @click="$router.push('menu')" v-if="!selectedcontact"  class="w3-button w3-border w3-round-xxlarge">&#171;&#171;</button>
    <button @click="clearSelected()" v-if="selectedcontact" class="w3-button w3-border w3-round-xxlarge">&#171;&#171; {{selectedcontact.displayname}} {{selectedphone}} </button>

    <template v-if="contacts && !selectedcontact">
     
      <ul class="w3-ul w3-panel w3-border w3-round-large">
        <li v-for="(contactdetails, phone) in contacts" :key="phone" class="container">
          <!-- <div>{{contactdetails}}</div> -->
          <button @click="createMessage(contactdetails, phone)" class="w3-button w3-block w3-border w3-round-xxlarge">
              <div>{{contactdetails.displayname}} Mobile:{{phone}} </div>
          </button>
        </li>
      </ul>
    </template>

    <template v-if="selectedcontact" class="w3-display-container">
      
      <div class="w3-ul w3-panel w3-border w3-round-large sms">                       
          <p>      
            <textarea class="w3-input w3-border" rows="15" style="resize:none" v-model="message"></textarea>
          </p>
          <button @click="createSendSMS();" v-if="message" class="w3-button w3-border w3-round-xxlarge">Send</button>
      </div>
    </template>


  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Contacts",
  data() {
    return { 
      msg: "Welcome to the Contacts page",
      selectedcontact:null,
      selectedphone:null,
      message:null
    };
  },
  beforeCreated() {},
  created: function() {},
  mounted() {},
  methods: {    
    createMessage(contactdetails, phone) {
      this.selectedcontact = contactdetails;   
      this.selectedphone = phone;   
      this.message = null;   
    },
    clearSelected() {
      this.selectedcontact = null;
      this.selectedphone = null; 
      this.message=null;     
    },
    createSendSMS() {
      this.sendSMS({too:this.selectedphone,message:this.message})
      this.clearSelected()
    },
    ...mapActions(["sendSMS"])
  },
  computed: {
    ...mapGetters(["user","contacts"])
  },
  beforeDestroy() {},
  destroy() {
    this.clearSelected()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.contacts {
  padding-top: 10px;
}


.contacts_order_lines {
  padding-top: 10px;
}

.sms {
  padding-bottom: 10px;
}
.footer {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contacts.vue